import React, { useState, useEffect } from "react";
import { Card, Form, Row, Col, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import * as apicall from "../../components/Apicall";

const ContactInformation = () => {
  const userDetails = JSON.parse(localStorage.getItem("user_details"));
  const id = userDetails?.id;

  const [form, setForm] = useState({
    first_name: "",
    phone_number: "",
    email: "",
    role: ""
  });

  useEffect(() => {
    if (userDetails) {
      setForm({
        first_name: userDetails.first_name || "",
        phone_number: userDetails.phone_number || "",
        email: userDetails.email || "",
        role: userDetails.role || ""
      });
    }
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSave = async () => {
    try {
      // Only send editable fields
      const payload = {
        first_name: form.first_name,
        phone_number: form.phone_number
      };

      const res = await apicall.post(payload, `updateUsers/${id}`);

      if (res.success) {
        toast.success("Updated Successfully");

        const updatedLocal = {
          ...userDetails,
          first_name: form.first_name,
          phone_number: form.phone_number,
        };

        localStorage.setItem("user_details", JSON.stringify(updatedLocal));
      } else {
        toast.error("Update Failed");
      }
    } catch (err) {
      toast.error("Something went wrong");
    }
  };

  return (
    <div className="container mt-4">
      <Card className="p-4">
        <h5>Contact Information</h5>
        <p className="text-muted">Update your personal contact details</p>

        <Form>
          <Row className="mb-3">

            {/* Name */}
            <Col md={4}>
              <Form.Group>
                <Form.Label>Name</Form.Label>
                <Form.Control
                  type="text"
                  name="first_name"
                  value={form.first_name}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>

            {/* Email (readonly) */}
            <Col md={4}>
              <Form.Group>
                <Form.Label>Email</Form.Label>
                <Form.Control
                  disabled
                  type="text"
                  name="email"
                  value={form.email}
                />
              </Form.Group>
            </Col>

            {/* Phone */}
            <Col md={4}>
              <Form.Group>
                <Form.Label>Phone</Form.Label>
                <Form.Control
                  type="text"
                  name="phone_number"
                  value={form.phone_number}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>

          </Row>

          {/* Role (readonly) */}
          <Row className="mb-3">
            <Col md={4}>
              <Form.Group>
                <Form.Label>Role</Form.Label>
                <Form.Control
                  disabled
                  type="text"
                  name="role"
                  value={form.role}
                />
              </Form.Group>
            </Col>
          </Row>

          <Button variant="danger" onClick={handleSave}>
            Save Changes
          </Button>
        </Form>
      </Card>
    </div>
  );
};

export default ContactInformation;
